import React from 'react';
import { LFC } from '../../../Legacy';
import { JiraProjectLiteData } from '../../../api/endpoints/jira';
import { Icon } from '../../../concepts/resources/Icon';
import { usePrompt } from '../../../ui';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { SelectJiraIssuesFromProjectView } from '../../external/atlassian/SelectJiraIssuesFromProjectView';
import { Popup, PopupProps } from '../../popups/Popup';

export const importFromJiraProjectPopup = (jiraProject: JiraProjectLiteData) => ({ ui: ImportFromJiraProjectPopup, args: { jiraProject } });

export const ImportFromJiraProjectPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const { jiraProject } = args;

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    return <Popup w="100" h="80%" ref={promptRef} p="1">
        <Popup.Header>
            <Popup.IconFrame>
                <Icon src="deqo://icons/i8/color-jira" size="2" />
            </Popup.IconFrame>
            <Popup.Title>
                Import From Jira
            </Popup.Title>
            <Popup.SubTitle>
                Create tickets from Jira by bringing them into your board!
            </Popup.SubTitle>
        </Popup.Header>
        <Popup.Content>
            <Flexer height=".5" />
            <SelectJiraIssuesFromProjectView jiraProjectId={jiraProject.id} onSelect={action} />
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
